// Description: This file contains functions for managing cookies.

/*
* Cookie Settings
*/
const acceptedCookieValues = ['AcceptedTypes=ALL', 'AcceptedTypes=Necessary,Tracking', 'AcceptedTypes=Necessary'];
const privacyCookieName = 'rtCookiePrivacySetting';

/**
 * Retrieves the value of a cookie by its name.
 * @param {string} cookieName - The name of the cookie.
 * @returns {string} The value of the cookie.
 */
const getCookie = (cookieName) => {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieList = decodedCookie.split(';');

    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
    return "";
};

/**
 * Sets a cookie with the given name and value.
 * @param {string} cookieName - The name of the cookie.
 * @param {string} cookieValue - The value of the cookie.
 */
const setCookie = (cookieName, cookieValue) => {
    const d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cookieName}=${cookieValue};${expires};path=/`;
};

/**
 * Deletes a cookie by its name.
 * @param {string} cookieName - The name of the cookie to delete.
 */
const deleteCookie = (cookieName) => {
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

/**
 * Checks if a cookie exists with the specified name and value.
 * @param {string} cookieName - The name of the cookie to check.
 * @param {string} targetValue - The value to check for.
 * @returns {boolean} True if a cookie with the specified name and value exists, otherwise false.
 */
function checkCookieExistsWithValue(cookieName, targetValue) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(cookieName + '=')) {
            const cookieValue = cookie.substring(cookieName.length + 1);
            if (cookieValue === targetValue) {
                return true;
            }
        }
    }
    return false;
}

/**
 * Checks if the user has accepted the cookie policy.
 * @returns {boolean} True if the user has accepted the cookie policy, otherwise false.
 */
const hasAcceptedCookiePolicy = () => {
    const accepted = acceptedCookieValues.some(value => {
        if (checkCookieExistsWithValue(privacyCookieName, value)) {
            debug('Cookie popup already accepted.');
            return true;
        }
    });
    if (!accepted) {
        debug('Cookie popup not accepted.');
    }
    return accepted;
};

/**
* Fixes the Cookie Policy Modal for Brave Browser.
* If the Cookie Policy element and the Cookie Policy Modal element exist,
* and the Cookie Policy element is hidden, the Cookie Policy Modal element will also be hidden.
*/
const setCookiePolicyVisibility = () => {
    if (hasAcceptedCookiePolicy()) { return; }
    let iterations = 0;
    const intervalId = setInterval(() => {
        debug('Checking for Cookie Policy elements');
        iterations++;
        const cookiePolicy = document.querySelector('#CookiePolicy');
        const cookiePolicyModal = document.querySelector('#CookiePolicyModal');
        if (cookiePolicy === null || cookiePolicyModal === null) {
            clearInterval(intervalId);
            debug('Cookie Policy elements not found');
            return;
        }
        if (window.getComputedStyle(cookiePolicy).display === 'none') {
            if (window.getComputedStyle(cookiePolicyModal).display !== 'none') {
                cookiePolicyModal.style.display = 'none';
                debug('Cookie Policy Modal hidden');
            }
            debug('Cookie Policy hidden');
            clearInterval(intervalId);
        }
        if (!isBrowser('brave') && iterations > 1000) {
            clearInterval(intervalId);
            debug('Cookie Policy fix not required');
        }
    }, 1);
};
